export class Interruptible<T> {
  promise: Promise<T>;
  interrupt!: (reason?: any) => void;

  constructor(promise: Promise<T>) {
    this.promise = new Promise<T>((resolve, reject) => {
      promise.then(resolve).catch(reject);

      this.interrupt = reject;
    })
  }

  replace(promise: Promise<T>) {
    this.interrupt();

    this.promise = new Promise<T>((resolve, reject) => {
      promise.then(resolve).catch(reject);

      this.interrupt = reject;
    })
  }
}
